import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=5eeeb3b2&"
import script from "./comment.vue?vue&type=script&lang=ts&"
export * from "./comment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "comment.vue"
export default component.exports